import { useEffect } from "react";
import { initPropertyPageTracking, trackValuationRequest, trackCTAClick } from "@/lib/analytics";
import ManchesterHero from "./manchester/ManchesterHero";
import ManchesterKeyBenefits from "./manchester/ManchesterKeyBenefits";
import ManchesterLandlordProof from "./manchester/ManchesterLandlordProof";
import GuestExperience from "./manchester/GuestExperience";
import ManchesterHowItWorks from "./manchester/ManchesterHowItWorks";
import ManchesterEarningsExplorer from "./manchester/ManchesterEarningsExplorer";
import WhatWeHandle from "./manchester/WhatWeHandle";
import ManchesterRiskReversal from "./manchester/ManchesterRiskReversal";
import ManchesterContact from "./manchester/ManchesterContact";
import ManchesterDistribution from "./manchester/ManchesterDistribution";
import ManchesterShortLetCase from "./manchester/ManchesterShortLetCase";
import ManchesterFAQNew from "./manchester/ManchesterFAQNew";
import ManchesterPropertyTypes from "./manchester/ManchesterPropertyTypes";
import ManchesterFinalCTA from "./manchester/ManchesterFinalCTA";

export default function Manchester() {
  useEffect(() => {
    const cleanup = initPropertyPageTracking('/management/manchester/');

    window.trackValuationRequest = () => trackValuationRequest('Manchester');
    window.trackCTAClick = (type) => trackCTAClick(type, 'Manchester');

    document.title = "Airbnb Management Manchester | From 12% + VAT | Truestays";

    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.name = name; document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setOgMeta = (property, content) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("property", property); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };

    setMeta("description", "Full-service Airbnb management in Manchester from 12% + VAT. Dynamic pricing, AO Arena and Old Trafford event surges, 16+ platforms. 35,000+ stays managed. Free income estimate.");
    setMeta("robots", "index, follow");
    setMeta("keywords", "airbnb management manchester, short let management manchester, property management manchester, airbnb host manchester, serviced accommodation manchester");
    setOgMeta("og:type", "website");
    setOgMeta("og:title", "Airbnb Management Manchester | From 12% + VAT | Truestays");
    setOgMeta("og:description", "Full-service Airbnb management in Manchester from 12% + VAT. Dynamic pricing, AO Arena and Old Trafford event surges, 16+ platforms. 35,000+ stays managed. Free income estimate.");
    setOgMeta("og:url", window.location.origin + "/management/manchester/");

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = "https://truestays.co.uk/management/manchester/";

    const schemaId = "ts-schema-manchester";
    let existingScript = document.getElementById(schemaId);
    if (existingScript) existingScript.remove();
    const script = document.createElement("script");
    script.id = schemaId;
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        { "@type": "LocalBusiness", "@id": "https://truestays.co.uk/management/manchester/", "name": "Truestays — Airbnb Management Manchester", "description": "Full-service Airbnb and short-let management in Manchester from 12% + VAT.", "url": "https://truestays.co.uk/management/manchester/", "priceRange": "From 12% + VAT", "areaServed": { "@type": "City", "name": "Manchester" }, "aggregateRating": { "@type": "AggregateRating", "ratingValue": "5.0", "reviewCount": "90", "bestRating": "5" } },
        { "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Home", "item": "https://truestays.co.uk/" }, { "@type": "ListItem", "position": 2, "name": "Management", "item": "https://truestays.co.uk/management/" }, { "@type": "ListItem", "position": 3, "name": "Manchester", "item": "https://truestays.co.uk/management/manchester/" }] }
      ]
    });
    document.head.appendChild(script);
    return () => {
      const s = document.getElementById(schemaId);
      if (s) s.remove();
      cleanup();
    };
  }, []);

  return (
    <>
      <ManchesterHero />
      <ManchesterKeyBenefits />
      <ManchesterEarningsExplorer />
      <ManchesterLandlordProof />
      <WhatWeHandle />
      <ManchesterHowItWorks />
      <ManchesterRiskReversal />
      <ManchesterShortLetCase />
      <ManchesterContact />
      <GuestExperience />
      <ManchesterDistribution />
      <ManchesterFAQNew />
      <ManchesterPropertyTypes />
      <ManchesterFinalCTA />
    </>
  );
}